module.exports = __webpack_public_path__ + "img/armor-shield-kite.4359436d.svg";